module.exports = __webpack_public_path__ + "static/media/yahoo-social-media-svgrepo-com (1).d8ca6dd7.svg";